"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionHeader = SectionHeader;
var _Text = _interopRequireDefault(require("react-native-web/dist/exports/Text"));
var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));
var _UiThemeProvider = require("../theme/UiThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Consistent section heading for analysis and dashboard surfaces. */
function SectionHeader({
  title,
  subtitle,
  action,
  style,
  ...rest
}) {
  const theme = (0, _UiThemeProvider.useUiTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
    ...rest,
    style: [{
      flexDirection: 'row',
      alignItems: subtitle ? 'flex-start' : 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing.sm
    }, style],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: {
        flexShrink: 1
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: {
          fontSize: theme.fontSizes.subtitle,
          fontWeight: '600',
          color: theme.palette.text
        },
        children: title
      }), subtitle ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: {
          fontSize: theme.fontSizes.small,
          color: theme.palette.textSecondary,
          marginTop: 2
        },
        children: subtitle
      }) : null]
    }), action ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: {
        flexShrink: 0
      },
      children: action
    }) : null]
  });
}